import React from "react";
import { FaPen } from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";
import ListAlt from "@material-ui/icons/ListAlt";
import HelpOutline from "@material-ui/icons/HelpOutline";
import Help from "@material-ui/icons/Help";
import ImportContacts from "@material-ui/icons/ImportContacts";
import MenuBook from "@material-ui/icons/MenuBook";
import CreditCard from "@material-ui/icons/CreditCard";
import PermIdentity from "@material-ui/icons/PermIdentity";
import PostAdd from "@material-ui/icons/PostAdd";
import CreateOutlined from "@material-ui/icons/CreateOutlined";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import ContactPhoneOutlined from "@material-ui/icons/ContactPhoneOutlined";
import ContactSupportOutlined from "@material-ui/icons/ContactSupportOutlined";
import PermIdentityOutlined from "@material-ui/icons/PermIdentityOutlined";
import LocalLibraryOutlined from "@material-ui/icons/LocalLibraryOutlined";
import BookmarkBorderOutlined from "@material-ui/icons/BookmarkBorderOutlined";

const icons = {
  first: MdAccountBalance, second: FaPen, third: ListAlt, forth: HelpOutline,
  fifth: Help, sixth: ImportContacts, seventh: MenuBook, eighth: CreditCard,
  ninth: PermIdentity, thenth: PostAdd, twelveth: CreateOutlined,
  thirteenth: KeyboardArrowDown, forteenth: ContactPhoneOutlined,
  fifteenth: ContactSupportOutlined, sixteenth: PermIdentityOutlined,
  seventeenth: LocalLibraryOutlined, eigtheen: BookmarkBorderOutlined
};

export default function ReportCardIcon({ icon, size = 50 }) {
  const Icon = Object.prototype.hasOwnProperty.call(icons, icon) ? icons[icon] : ListAlt;
  return <Icon aria-hidden="true" style={{ color: "#FF9B14", fontSize: size }} />;
}
